import client from '../lib/http-client';

const endpoint = '/settings';

export default {
	// Get List
	getList(params, cb, errorCb) {
		const url = `${endpoint}`;
		client.get(url, { params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Get Current
	getCurrent(params, cb, errorCb) {
		const url = `${endpoint}/current`;
		client.get(url, { params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Get Google Analytics Key
	getGoogleAnalyticsKey(cb, errorCb) {
		const url = `${endpoint}/google_analytics_key`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Get Meta Pixels
	getMetaPixels(cb, errorCb) {
		const url = `${endpoint}/meta-pixels`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Change Value
	changeValue(params, cb, errorCb) {
		const url = `${endpoint}`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},
};
